import Modal from "../Modal";
import OpportunityNewForm from "../../forms/opportunity/OpportunityNewForm";
import OpportunityAddItemsForm from "../../forms/opportunity/OpportunityAddItemsForm";
import OpportunityNewModal from "./OpportunityNewModal";
import OpportunityAddItemsModal from "./OpportunityAddItemsModal";
import {useState} from "react";
import { useTranslation } from "../../../hooks/useTranslation";

export default function OpportunityItemsModal({show, handleClose, items = null, title}) {
    const { t } = useTranslation();
    const [showModalNew, setShowModalNew] = useState(false);
    const [showModalAddItems, setShowModalAddItems] = useState(false);
    return (
        <>
            <OpportunityNewModal show={showModalNew}
                                 handleClose={()=>setShowModalNew(false)}
                                 items={items}/>

            <OpportunityAddItemsModal show={showModalAddItems}
                                      handleClose={()=>setShowModalAddItems(false)}
                                      items={items}/>

        <Modal title={title || t("opportunities.insertProductToOpportunity")} show={show} handleClose={handleClose}>
            <div className="py-5">
                <div className="text-center">
                    <button className="btn btn-success"
                       onClick={()=>setShowModalNew(true)}
                    >{t("opportunities.createNew")}
                    </button>
                </div>
            </div>
            <div className="separator"></div>
            <div className="py-5">
                <div className="text-center">
                    <button className="btn btn-primary"
                            onClick={()=>setShowModalAddItems(true)}
                    >{t("opportunities.insertToExisting")}
                    </button>
                </div>
            </div>
        </Modal>
        </>
    );
};